module.exports = __webpack_public_path__ + "static/testi-8-b2b3b21691e6c0c5548a5a4da27c06a8.jpg";